export default __webpack_public_path__ + "static/media/Gilroy-Heavy.ffe93981.ttf";